module.exports = __webpack_public_path__ + "img/birthday-cake.4a920c06.svg";